import { usePatientReview } from "../../services/useData";
import { GetCurrentDate, ProcessReviewData } from "../../util/data-utils";
import { useCallback, useContext, useMemo, useReducer } from "react";
import { ReviewContext } from "../ReviewPatient";
import { PatientContext } from "../ActivePatients";
import PatientData from "../PatientData";
import ReviewHistory from "../ReviewHistory";
import ReviewOutcome from "../ReviewOutcome";
import LoadingSpinner from "../../Components/LoadingSpinner";
import { WEEKLY_REVIEW_OFFSET } from "../../util/const";

const PatientReviewFragment = () => {

  const context = useContext(PatientContext);
  const patient = context.patient;

  const reviewState = { weekEnding:GetCurrentDate() }
  const enum REDUCER_ACTION_TYPE {
    WEEKEND_CHANGED
  }
  type ReducerAction = {
    type: REDUCER_ACTION_TYPE.WEEKEND_CHANGED,
    payload: {
      endAt: string
    }
  }
  const reducer = (state: typeof reviewState, action: ReducerAction): typeof 
  reviewState => {
    switch(action.type)
    {       
      case REDUCER_ACTION_TYPE.WEEKEND_CHANGED: {
        return {...state, weekEnding: action.payload.endAt }
      }
      default: return state;
    }
  }
  const [review, dispatch] = useReducer(reducer, reviewState);

  // Fetch the data - this will re-run each time a parameter changes
  const fetchedData = usePatientReview({
    id: patient.resourceId,
    endDate: review.weekEnding,
    offset: WEEKLY_REVIEW_OFFSET
  });

  if(!fetchedData.isLoading && !fetchedData.isValidating)
    ProcessReviewData(fetchedData.review, patient);

  const reload = useCallback(() => {
    fetchedData.mutate();
  }, [fetchedData]);

  const moreData = useCallback((endAtDate: string) => {
    dispatch({type: REDUCER_ACTION_TYPE.WEEKEND_CHANGED, payload: {endAt: endAtDate }});
  }, [REDUCER_ACTION_TYPE.WEEKEND_CHANGED]);

  const weekEnding = review.weekEnding;
  const reviewContextValue = useMemo(
    () => ({ patient, weekEnding, moreData, reload }),
    [patient, weekEnding, moreData, reload]
  );

  if(fetchedData.isLoading)
  {
    return (<LoadingSpinner />);
  }

  return (
    <ReviewContext.Provider value={reviewContextValue}>
      <PatientData/> 
      <ReviewOutcome />
      <ReviewHistory />
    </ReviewContext.Provider>
  )    
}

export default PatientReviewFragment;